<rt-dialog-header [heading]="translationKeys[groupKind].header | translate" class="error">
</rt-dialog-header>
<rt-dialog-body>
  <div class="member-details">
    <rt-avatar
      [type]="!!member.avatarThumbUrl ? 'image' : 'initials'"
      [imageSrc]="member.avatarThumbUrl"
      [fullName]="member.fullName"
      context="admin"
    ></rt-avatar>
    <div class="member-name">
      <div class="name-wrapper">
        <rt-heading>{{ member.fullName }}</rt-heading>
      </div>
      @if (member.email) {
        <span class="email">{{ member.email }}</span>
      }
    </div>
  </div>

  <span
    [innerHTML]="translationKeys[groupKind].desc1 | translate: { groupName: groupName }"
    class="desc"
    padding-top
    padding-bottom-small
  >
  </span>
  <span class="desc">
    {{ translationKeys[groupKind].desc2 | translate }}
  </span>
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button [loading]="loading()" (click)="confirm()" variant="error" class="optional">
    {{ translationKeys[groupKind].confirm | translate }}
  </rt-button>
  <rt-button (click)="close()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
</rt-dialog-footer>
